// extracted by mini-css-extract-plugin
export default {"errorImg":"ErrorHandling_errorImg__HXAn1","errorWrapper":"ErrorHandling_errorWrapper__-G1AS"};